module.exports = __webpack_public_path__ + "static/media/29BDOS25.e2640d51.jpg";